import Vue from "vue";
import App from "./App.vue";
import Macau from "./Macau.vue";
import Gbp from "./Gbp.vue";
import numeral from "numeral";
import CalculatorCard from "./components/CalculatorCard.vue";
import NewCompany from "./components/calculators/NewCompany";
import SimpleVueValidation from "simple-vue-validator";
import ProfessionalIncomeTax from "./components/calculators/ProfessionalIncomeTax.vue";
import IncomeTax from "./components/calculators/IncomeTax.vue";

import Buefy from "buefy";
import "buefy/dist/buefy.css";

import { i18n, i18nEn, i18nCn, i18nPo } from "./i18n/i18n";

Vue.use(Buefy);
Vue.use(SimpleVueValidation, {
  mode: "manual",
  templates: {
    required: "simpleVueValidator_required",
    integer: "simpleVueValidator_integer",
    greaterThan: "simpleVueValidator_greaterThenZero",
    email: "simpleVueValidator_email",
    maxLength: "最多{0}字符",
    length: "必須為{0}位",
    greaterThanOrEqualTo: "數量必須大於或等於{0}",
    lessThanOrEqualTo: "必須小於或等於 {0} 分",
    match: "不匹配",
    lessThan: "simpleVueValidator_lessThan",
  },
});

const Validator = SimpleVueValidation.Validator;
Vue.prototype.$validator = () => Validator;

Vue.filter("formatNumberWithoutPoint", function(value) {
  return numeral(value).format("0, 0", Math.ceil);
});

Vue.filter("formatNumber", function(value) {
  return numeral(value).format("0, 0.00", Math.ceil);
});

Vue.config.productionTip = false;
Vue.component("CalculatorCard", CalculatorCard);
Vue.component("NewCompany", NewCompany);
Vue.component("ProfessionalIncomeTax", ProfessionalIncomeTax);
Vue.component("IncomeTax", IncomeTax);
new Vue({
  render: (h) => h(App),
  i18n,
}).$mount("#app");

//

new Vue({
  render: (j) => j(Macau),
  i18n,
}).$mount("#macau");

new Vue({
  render: (k) => k(Macau),
  i18n: i18nEn,
}).$mount("#macauEn");

new Vue({
  render: (l) => l(Macau),
  i18n: i18nCn,
}).$mount("#macauCn");

new Vue({
  render: (q) => q(Macau),
  i18n: i18nPo,
}).$mount("#macauPo");

//

new Vue({
  render: (w) => w(Gbp),
  i18n,
}).$mount("#gba");

new Vue({
  render: (e) => e(Gbp),
  i18n: i18nEn,
}).$mount("#gbaEn");

new Vue({
  render: (r) => r(Gbp),
  i18n: i18nCn,
}).$mount("#gbaCn");

new Vue({
  render: (t) => t(Gbp),
  i18n: i18nPo,
}).$mount("#gbaPo");
